import React, { useState } from 'react';
import { Divider, CircularProgress, Button, Box } from '@mui/material';
import {
    formatFileSize,
    getCurrencySymbol,
    toFixedTrunc,
    useJunoCommonFunctions,
} from '../../../../client/Juno/helpers';
import TransactionCommonModal from '../../common/TransactionCommonModal';
import { useSelector } from 'react-redux';
import MobileConfirmation from '../MoobileConfirmaion';
import { formatCurrency } from '../../../helpers/constant';

const PayoutConfirm = ({
    open,
    onClose,
    onBack,
    title,
    formData = {},
    attachments,
    handleCreate,
}) => {
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState(1);
    const imageBaseURl = useSelector(state => state.config.image_base_url);
    const { useWindowWidth } = useJunoCommonFunctions();

    const windowWidth = useWindowWidth();

    const handleExchangeClick = () => {
        setLoading(true);
        handleCreate(attachments, setLoading);
    };

    const handleClick = page => {
        setPagination(page);
    };

    const {
        selectedCurrency: { currencyShortName, currencyFullName, currencyIcon, balanceAmount } = {},
        fiatAmount,
        beneficiaryName = '-',
        beneficiaryAddress = '-',
        bankName = '-',
        bankAddress = '-',
        sortCode = '-',
        swift = '-',
        iban = '-',
        reference = '-',
        additionalInfo = '-',
        bankCountry = '-',
        beneficiaryCountry = '-',
        beneficiaryAccountNumber = '-',
        additionalBankDetails = '-',
    } = formData;

    const beneficiaryDetails = [
        { label: 'Beneficiary Name', value: beneficiaryName || '-' },
        { label: 'Beneficiary Country', value: beneficiaryCountry || '-' },
        {
            label: 'Beneficiary Address',
            value: beneficiaryAddress || '-',
            width: 'w-[244px]',
        },
        { label: 'Bank Name', value: bankName || '-' },
        { label: 'Bank Country', value: bankCountry || '-' },
        {
            label: 'Bank Address',
            value: bankAddress || '-',
            width: 'w-[244px]',
        },
    ];
    const accountDetails = [
        { label: 'Account number:', value: beneficiaryAccountNumber || '-' },
        { label: 'Sort Code:', value: sortCode || '-' },
        { label: 'SWIFT:', value: swift || '-' },
        { label: 'IBAN:', value: iban || '-' },
    ];
    const attachmentsDetails = attachments?.files?.map(attachment => ({
        label: attachment.name,
        value: formatFileSize(attachment.size),
    }));

    const data = {
        title: (title === 'withdrawal' ? 'Withdraw' : title) + ' amount',
        amount: formatCurrency(fiatAmount, currencyShortName),
        balance: formatCurrency(balanceAmount, currencyShortName),
        currencyIcon,
        currencyShortName,
        details: [
            ...beneficiaryDetails,
            ...accountDetails,
            { label: 'Reference', value: reference || '-' },
            { label: 'Additional info', value: additionalBankDetails || '-' },
        ],
        attachments: attachmentsDetails,
    };

    return (
        <TransactionCommonModal
            heading={`${title} confirmation`}
            open={open}
            {...(windowWidth <= 640 && {
                bottomButtonText: loading ? 'Processing...' : 'CONFIRM',
                onBottomButtonClick: !loading ? handleExchangeClick : () => {},
                showCloseIcon: false
            })}
            onBack={!loading ? onBack : () => {}}
            onClose={!loading ? onClose : () => {}}
            showBackButton={true}>
            <>
                {windowWidth <= 640 ? (
                    <MobileConfirmation data={data} component={`withdrawal`} />
                ) : (
                    <>
                        {pagination === 1 && (
                            <>
                                <div>
                                    <p className="text-sm text-payout-confirm-details-color font-medium uppercase mb-2">
                                        {`${title == 'withdrawal' ? 'Withdraw' : title}`} amount
                                    </p>
                                    <div className="rounded-md border-1 border-gray-300 dark:border-[#51525C] bg-gray-50 dark:bg-[#FFFFFF0A] px-3 py-2 mb-6">
                                        <div className="flex items-center justify-between min-h-[32px]">
                                            <div className="flex gap-2">
                                                <img
                                                    src={`${imageBaseURl}${currencyIcon}`}
                                                    className="w-6 h-6 self-center"
                                                />
                                                <p className="text-[#18181B] dark:text-white py-2 text-base font-medium leading-6">
                                                    {currencyFullName}
                                                </p>
                                            </div>
                                            <p className="text-[#18181B] dark:text-white py-2 text-right text-lg font-medium">
                                                {getCurrencySymbol(currencyShortName)}
                                                {fiatAmount} ({currencyShortName})
                                            </p>
                                        </div>
                                        <Divider
                                            sx={{
                                                bgcolor: '#D1D1D6',
                                                height: 1,
                                                width: 1,
                                                marginTop: '0px !important',
                                                marginBottom: '0px !important',
                                            }}
                                        />
                                        <div className="flex items-center justify-between min-h-[32px]">
                                            <p className="dark:text-[#D1D1D6] text-xs font-medium leading-4">
                                                BALANCE:
                                            </p>
                                            <p className="text-[#18181B] dark:text-white py-2 text-right text-xs font-medium leading-4">
                                                {getCurrencySymbol(currencyShortName)}
                                                {toFixedTrunc(balanceAmount, 2)} (
                                                {currencyShortName})
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p className="text-sm text-payout-confirm-details-color font-medium uppercase mb-2">
                                        Beneficiary Details
                                    </p>
                                    <div className="rounded-md border-1 border-gray-300 bg-gray-50 dark:bg-[#FFFFFF0A] px-3 py-2 mb-6 dark:border-[#51525C]">
                                        {beneficiaryDetails.map(
                                            ({ label, value, width = '' }, idx) => (
                                                <React.Fragment key={idx}>
                                                    <div className="flex items-center justify-between min-h-[32px]">
                                                        <p className="text-payout-confirm-details-color font-medium text-[12px] leading-[16px] uppercase">
                                                            {label}:
                                                        </p>
                                                        <p
                                                            className={`text-[#18181B] dark:text-white py-2 text-right font-medium text-[12px] leading-[16px] uppercase ${width}`}>
                                                            {value}
                                                        </p>
                                                    </div>
                                                    {idx !== beneficiaryDetails.length - 1 && (
                                                        <Divider
                                                            sx={{
                                                                bgcolor: '#D1D1D6',
                                                                height: 1,
                                                                width: 1,
                                                                marginTop: '0px !important',
                                                                marginBottom: '0px !important',
                                                            }}
                                                        />
                                                    )}
                                                </React.Fragment>
                                            ),
                                        )}
                                    </div>
                                </div>
                            </>
                        )}

                        {pagination === 2 && (
                            <div>
                                <p className="text-sm text-payout-confirm-details-color font-medium uppercase mb-2">
                                    Bank Account Details
                                </p>
                                <div className="rounded-md border-1 border-gray-300 dark:border-[#51525C] bg-gray-50 dark:bg-[#FFFFFF0A] px-3 py-2 mb-6">
                                    {accountDetails.map(({ label, value, width }, idx) => (
                                        <React.Fragment key={idx}>
                                            <div className="flex items-center justify-between min-h-[32px] m-0">
                                                <p className="text-payout-confirm-details-color font-medium text-[12px] leading-[16px] uppercase">
                                                    {label}
                                                </p>
                                                <p
                                                    className={`text-[#18181B] dark:text-white py-2 text-right font-medium text-[12px] leading-[16px] uppercase ${
                                                        width || ''
                                                    }`}>
                                                    {value}
                                                </p>
                                            </div>
                                            {idx !== accountDetails.length - 1 && (
                                                <Divider
                                                    sx={{
                                                        bgcolor: '#51525C',
                                                        height: 2,
                                                        marginTop: '0px !important',
                                                        marginBottom: '0px !important',
                                                    }}
                                                />
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div>
                                    <p className="text-sm text-payout-confirm-details-color font-medium uppercase mb-2">
                                        REFERENCE
                                    </p>
                                    <div className="rounded-md border-1 border-gray-300 dark:border-[#51525C] bg-gray-50 dark:bg-[#FFFFFF0A] px-3 py-2 mb-6">
                                        <div className="flex items-center justify-between min-h-[32px]">
                                            <p className="text-[#18181B] dark:text-white py-2 font-medium text-[12px] leading-[16px] uppercase">
                                                {reference || '-'}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p className="text-sm text-payout-confirm-details-color font-medium uppercase mb-2">
                                        ADDITIONAL INFO
                                    </p>
                                    <div className="rounded-md border-1 border-gray-300 dark:border-[#51525C] bg-gray-50 dark:bg-[#FFFFFF0A] px-3 py-2 mb-6">
                                        <div className="flex items-center justify-between min-h-[32px]">
                                            <p className="text-[#18181B] dark:text-white py-2 font-medium text-[12px] leading-[16px] uppercase">
                                                {additionalBankDetails || '-'}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {pagination === 3 && (
                            <div>
                                <p className="text-sm text-payout-confirm-details-color font-medium uppercase mb-2">
                                    ATTACHMENTS
                                </p>
                                <div className="rounded-[6px] border-1 dark:border-[#51525C] dark:bg-[#FFFFFF0A] px-3 py-2 mb-6 space-y-2">
                                    {attachmentsDetails?.length ? (
                                        attachmentsDetails.map(({ label, value, width }, idx) => (
                                            <React.Fragment key={idx}>
                                                <div className="flex items-center justify-between min-h-[32px] m-0">
                                                    <p className="text-[#51525C] dark:text-white font-medium text-[12px] leading-[16px] uppercase">
                                                        {label}
                                                    </p>
                                                    <p
                                                        className={`text-[#18181B] dark:text-white py-2 text-right font-medium text-[12px] leading-[16px] uppercase ${
                                                            width || ''
                                                        }`}>
                                                        {value}
                                                    </p>
                                                </div>
                                                {idx !== attachmentsDetails.length - 1 && (
                                                    <Divider
                                                        sx={{
                                                            bgcolor: '#51525C',
                                                            height: 2,
                                                            marginTop: '0px !important',
                                                            marginBottom: '0px !important',
                                                        }}
                                                    />
                                                )}
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <p className="text-text text-uppercase text-payout-confirm-details-color">
                                            No Attachments found
                                        </p>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Pagination */}
                        <div className="flex justify-center gap-2 mb-6">
                            {[1, 2, 3].map(page => (
                                <button
                                    onClick={() => handleClick(page)}
                                    key={page}
                                    className={`w-8 h-8 rounded-[4px] text-sm font-semibold border-1 ${
                                        page === pagination
                                            ? 'bg-[#1A8A7E] text-white'
                                            : 'bg-[#E4E4E7] dark:bg-[#3F3F46]  text-[#18181B] dark:text-white border-transparent'
                                    }`}>
                                    {page}
                                </button>
                            ))}
                        </div>

                        <button
                            onClick={handleExchangeClick}
                            className="w-full bg-[#000] text-[#fff] dark:bg-white dark:text-[#18181B] px-8 py-3 rounded-[8px] text-sm font-semibold leading-5"
                            disabled={loading}
                            data-e2e="confirm/proceesing-btn">
                            {loading ? (
                                <div className="flex items-center gap-1 justify-center">
                                    PROCESSING
                                    <CircularProgress
                                        className="dark:text-[#18181B]"
                                        size={20}
                                        style={{ marginLeft: 8 }}
                                        thickness={8}
                                    />
                                </div>
                            ) : (
                                'CONFIRM'
                            )}
                        </button>
                    </>
                )}
            </>
        </TransactionCommonModal>
    );
};

export default PayoutConfirm;
